import { useFlags } from '@nx/launch-darkly-service';

import { useFeatureFlag } from './use-feature-flag';

export function useExternalConnectionsFlag() {
  const flags = useFlags();
  const [externalConnectionsEnabled] = useFeatureFlag('upx:external-connections');
  return flags.upxExternalConnections === true || externalConnectionsEnabled;
}
